<div *ngIf="!loading">
  <div class="mb-2 radio-box">
    <label class="vox-field-label">
      <input class="vox-radio" type="radio" value="BUSINESS"
        (change)="onRadioChange('BUSINESS')"
        [checked]="selectedType === 'BUSINESS'"/>
      {{ 'company.did.add-verification-data-popup.type.business' | translate }}</label>
      <label class="vox-field-label">
        <input class="vox-radio" type="radio" value="PRIVATE"
          (change)="onRadioChange('PRIVATE')"
          [checked]="selectedType === 'PRIVATE'"/>
        {{'company.did.add-verification-data-popup.type.private' | translate}}</label>
  </div>
  <vox-verification-data-form
    *ngIf="selectedType === 'BUSINESS'"
    [loading]="loading"
    [verificationDataRequirements]="requirements?.BUSINESS"
    [googlePlaceAPIKey]="googlePlacesApiKey"
    [dense]="true"
    [country]="country"
    [language]="language"
    (onValueChange)="onValueEmitted($event)"
  ></vox-verification-data-form>
  <vox-verification-data-form
    *ngIf="selectedType === 'PRIVATE'"
    [loading]="loading"
    [verificationDataRequirements]="requirements?.PRIVATE"
    [googlePlaceAPIKey]="googlePlacesApiKey"
    [dense]="true"
    [country]="country"
    [language]="language"
    (onValueChange)="onValueEmitted($event)"
  ></vox-verification-data-form>
</div>
<div *ngIf="loading">
  <div class="mb-2">
    <div class="d-inline-block mr-3">
      <ngx-skeleton-loader appearance="circle" [theme]="{'width':'30px', 'height': '30px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader class="d-inline-block" [theme]="{'margin-bottom': '5px', 'width': '120px', 'height': '30px'}"></ngx-skeleton-loader>
    </div>
    <div class="d-inline-block">
      <ngx-skeleton-loader appearance="circle" [theme]="{'width':'30px', 'height': '30px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader class="d-inline-block" [theme]="{'margin-bottom': '5px', 'width': '120px', 'height': '30px'}"></ngx-skeleton-loader>
    </div>
  </div>
  <vox-verification-data-form [dense]="true" [loading]="loading"></vox-verification-data-form>
</div>
